var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 3,
    fill: "#F9B218"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.3506L9 23.0006L13.65 21.5006L10.5 18.3506Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8718 9.95306L11.5533 17.2715L14.7353 20.4534L22.0537 13.135L18.8718 9.95306Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7752 10.325L21.6752 8.225C21.3752 7.925 20.9252 7.925 20.6252 8.225L19.9502 8.9L23.1002 12.05L23.7752 11.375C24.0752 11.075 24.0752 10.625 23.7752 10.325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditButton);
export default __webpack_public_path__ + "static/media/icon-edit-button.9a93349fcafa3981f86ecc148f3c2e4d.svg";
export { ForwardRef as ReactComponent };